import React, { useEffect, useMemo, useState } from 'react';
import {
  Button,
  Image,
  message,
  Form,
  Input,
  Flex,
  Radio,
  InputNumber,
  Switch,
  Badge,
  Row,
  Col,
  Card,
  Modal,
  Tabs,
  Space,
  Divider,
  TimePicker,
} from 'antd';
import dayjs from 'dayjs';
import IntlMessage from '../../../components/IntlMessage';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import "./account.css";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
  entity_app_params,
  operator_params,
  sms_params,
  list_app_params,
} from '../../../utils/constant';
import accountOperatorApi from '../../../api/account';
import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import userOperatorApi from '../../../api/user-operator';

const AccountUser = (props) => {
  const { account, isEdit, onReload } = props;
  const [imgUrl, setImgUrl] = useState(null);
  const [check, setcheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgs, setImgs] = useState(false);
  const [timeSellingStart, setTimeSellingStart] = useState(false);

  const [isShowTime, setIsShowTime] = useState({
    user: false,
    op: false,
  });

  const user = useSelector((state) => state.auth.authUser);

  console.log('user', user, account);

  const queryClient = useQueryClient();

  const intl = useIntl();

  const col_company_info = {
    xl: { span: 12 },
    xs: { span: 24 },
    sm: { span: 24 },
  };

  const input_width = 300;

  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const is_operator = user?.email === account?.email ? true : false;

  let initialValues = {
    ...(is_operator ? { ...account } : { ...user }),
    phone: user?.mobile || '',
  };

  const fileList = useMemo(() => {
    return account?.image
      ? [
          {
            uid: '1',
            name: 'xxx.png',
            status: 'done',
            url: account?.image,
          },
        ]
      : [];
  }, [account]);

  const onChangeDescription = (event, editor) => {
    const data = editor.getData();
    form.setFieldsValue({ description: data });
  };

  const handleChange = (v, f) => {
    setImgUrl(f);
  };

  const onChangeTime = (time, timeString) => {
    setTimeSellingStart(timeString);
  };

  const onChangeRadioSelling = (e) => {
    const { value, name } = e.target;
    if (name === 'user_selling') {
      setIsShowTime((prev) => ({ ...prev, user: value === 'Custom' }));
    }
    if (name === 'op_selling') {
      setIsShowTime((prev) => ({ ...prev, op: value === 'Custom' }));
    }
  };

  // const tabItems = [
  //   {
  //     key: '1',
  //     label: <IntlMessage id="global.company_info" />,
  //     children: (
  //       <React.Fragment>
  //         {/* <Row gutter={[16, 16]}>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.title" />}
  //               name="title"
  //               style={{ marginTop: 20 }}
  //             >
  //               <Input />
  //             </Form.Item>
  //           </Col>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.short_name" />}
  //               name="short_name"
  //               style={{ marginTop: 20 }}
  //             >
  //               <Input />
  //             </Form.Item>
  //           </Col>
  //         </Row> */}

  //         <Row gutter={[16, 16]}>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.firstname" />}
  //               name="firstname"
  //               style={{ marginTop: 20 }}>
  //               <Input />
  //             </Form.Item>
  //           </Col>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.lastname" />}
  //               name="lastname"
  //               style={{ marginTop: 20 }}>
  //               <Input />
  //             </Form.Item>
  //           </Col>
  //         </Row>

  //         <Row gutter={[16, 16]}>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.phone" />}
  //               name="phone"
  //               style={{ marginTop: 20 }}>
  //               <Input />
  //             </Form.Item>
  //           </Col>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.email" />}
  //               name="email"
  //               style={{ marginTop: 20 }}>
  //               <Input readOnly />
  //             </Form.Item>
  //           </Col>
  //         </Row>

  //         {/* <Row gutter={[16, 16]}>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.email" />}
  //               name="email"
  //               style={{ marginTop: 20 }}>
  //               <Input readOnly />
  //             </Form.Item>
  //           </Col>
  //           <Col {...col_company_info}>
  //             <Form.Item
  //               label={<IntlMessage id="global.tax" />}
  //               name="tax"
  //               style={{ marginTop: 20 }}>
  //               <Input />
  //             </Form.Item>
  //           </Col>
  //         </Row> */}
  //       </React.Fragment>
  //     ),
  //   },
  // ];

  const updateMutateAccount = useMutation({
    mutationFn: (payload) => accountOperatorApi.update(account?.id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account'] });
      setLoading(false);
      message.success('Updated successfully');
      onReload();
    },
    onError: (error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    },
  });

  const updateMutateAccountAgent = useMutation({
    mutationFn: (payload) => userOperatorApi.update(user?.id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account'] });
      setLoading(false);
      message.success('Updated successfully');
      onReload();
    },
    onError: (error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    },
  });

  const handleSubmit = () => {
    // setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };

        if (data.mobile) {
          data.phone = data.mobile;
        }

        if (account && account.email === user.email) {
          updateMutateAccount.mutate(data, {
            onSettled: () => window.location.reload(),
          });
        } else {
          updateMutateAccountAgent.mutate(data, {
            onSettled: () => window.location.reload(),
          });
        }
      })
      .catch(() => setLoading(false));
  };

  return (
    <Form
      name="basic"
      labelAlign="left"
      {...layout}
      form={form}
      style={{ width: '100%', maxWidth: 1500 }}
      initialValues={initialValues}
      autoComplete="off">
      <React.Fragment>
        <Row gutter={[16, 16]}>
          <Col {...col_company_info}>
            <Form.Item
              label={<IntlMessage id="global.firstname" />}
              name="firstname"
              style={{ marginTop: 20 }}>
              <Input disabled style={{ color: 'black' }} />
            </Form.Item>
          </Col>
          <Col {...col_company_info}>
            <Form.Item
              label={<IntlMessage id="global.lastname" />}
              name="lastname"
              style={{ marginTop: 20 }}>
              <Input disabled style={{ color: 'black' }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col {...col_company_info}>
            <Form.Item
              label={<IntlMessage id="global.phone" />}
              name="phone"
              style={{ marginTop: 20 }}>
              <Input disabled style={{ color: 'black' }} />
            </Form.Item>
          </Col>
          <Col {...col_company_info}>
            <Form.Item
              label={<IntlMessage id="global.email" />}
              name="email"
              style={{ marginTop: 20 }}>
              <Input readOnly disabled style={{ color: 'black' }} />
            </Form.Item>
          </Col>
        </Row>
      </React.Fragment>

      {/* <Flex justify="flex-end">
        <Button
          htmlType="button"
          onClick={handleSubmit}
          type="primary"
          style={{ marginTop: 24 }}>
          {<IntlMessage id="global.save" />}
        </Button>
      </Flex> */}
    </Form>
  );
};

export default AccountUser;
